interface Check3DIconProps {
    className?: string;
    width?: number;
    height?: number;
}

const Check3DIcon = ({
    className,
    width = 65,
    height = 95,
}: Check3DIconProps) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 65 95'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.999901 39.9781V85.1845C0.999901 86.7413 1.77108 88.197 3.05908 89.0715L9.50848 93.4502L49.964 67.004C54.4673 64.0602 57.3741 59.2158 57.8527 53.857L62.1412 5.84123L55.236 1.67537C53.7805 0.797315 51.9643 0.773896 50.4867 1.61413L9.88724 24.7006C4.39333 27.8247 0.999901 33.6581 0.999901 39.9781Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.318597'
            />
            <path
                d='M1.00021 39.9782V85.1847C1.00021 86.7415 1.77139 88.1972 3.05939 89.0716L9.50879 93.4504L8.68691 43.7363L1.01798 39.1866C1.00617 39.4495 1.00021 39.7135 1.00021 39.9782Z'
                fill='#090B2A'
                stroke='#090B2A'
                strokeWidth='0.318597'
            />
            <path
                d='M64.0176 55.7875V9.57559C64.0176 5.9726 60.129 3.71052 56.997 5.49152L16.81 28.3435C11.3161 31.4676 7.92263 37.301 7.92263 43.621V89.9501C7.92263 93.5577 11.8201 95.8193 14.9522 94.0291L55.1638 71.0459C60.6388 67.9166 64.0176 62.0938 64.0176 55.7875Z'
                fill='#98E9AC'
                stroke='#090B2A'
                strokeWidth='0.318597'
            />
            <path
                d='M26.7165 50.1118L33.1682 57.053C33.2902 57.1843 33.5051 57.1575 33.5912 57.0002L46.6234 33.1744C47.4736 31.6201 49.4086 31.0278 50.9831 31.8401C52.6246 32.6869 53.237 34.7259 52.3336 36.337L35.9613 65.5351C35.262 66.7822 33.5574 67.0009 32.5659 65.9708L21.7886 54.7727C20.6007 53.5384 20.5197 51.6122 21.5997 50.2825C22.8991 48.6827 25.3133 48.6022 26.7165 50.1118Z'
                fill='white'
                stroke='#090B2A'
                strokeWidth='0.318597'
            />
            <path
                d='M58.3932 52.5373V14.1701C58.3932 12.8357 56.953 11.9979 55.793 12.6575L22.433 31.6274C16.9391 34.7515 13.5456 40.5848 13.5456 46.9048V85.3692C13.5456 86.7054 14.9891 87.543 16.1492 86.88L49.5394 67.7956C55.0145 64.6663 58.3932 58.8435 58.3932 52.5373Z'
                stroke='#090B2A'
                strokeWidth='0.318597'
            />
        </svg>
    );
};

export default Check3DIcon;
